import _createForOfIteratorHelper from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _toConsumableArray from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dayjs from 'dayjs';
import * as echarts from 'echarts';
export default {
  components: {
    labSel: function labSel() {
      return import('../../org/lab_sel.vue');
    },
    areaSel: function areaSel() {
      return import('../../org/lab_area_sel.vue');
    },
    dotBmap: function dotBmap() {
      return import('@/components/dotBmap.vue');
    }
  },
  data: function data() {
    return {
      dayjs: dayjs,
      params: {
        page: 1,
        limit: 20,
        sortField: '^report_date',
        labId: localStorage.getItem('labId')
      },
      labSpeciesData: {},
      show: true,
      labInfo: localStorage.getItem('labInfo') ? JSON.parse(localStorage.getItem('labInfo')) : {}
    };
  },
  mounted: function mounted() {
    this.getnationalProduction();
    this.getprovincialProduction();
    this.getlabProduction();
    this.getlabSpecies();
    this.getmarketPrice();
    this.getregionalSales();
  },
  watch: {
    show: function show(to) {
      var _this = this;
      if (to) {
        this.$nextTick(function () {
          _this.getnationalProduction();
          _this.getprovincialProduction();
          _this.getlabProduction();
          _this.getlabSpecies();
          _this.getmarketPrice();
          _this.getregionalSales();
        });
      }
    }
  },
  methods: {
    backClick: function backClick() {
      this.$router.back();
    },
    getnationalProduction: function getnationalProduction() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var option, res, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.echart1 = echarts.init(document.getElementById('nationalProduction'));
              _context.next = 3;
              return _this2.$api['nationalProductionQuery'](_objectSpread({}, _this2.params));
            case 3:
              res = _context.sent;
              result = _this2.transformToChart(res.data, 'reportDate', 'production');
              option = {
                tooltip: {
                  trigger: 'axis'
                },
                grid: {
                  bottom: 20,
                  top: 50,
                  right: 0,
                  left: 30
                },
                legend: {
                  left: 20,
                  top: 10,
                  icon: 'rect',
                  // 方块图标
                  itemWidth: 10,
                  // 方块宽度
                  itemHeight: 10,
                  // 方块高度
                  itemGap: 20,
                  // 图例之间间距
                  textStyle: {
                    color: '#ffffff',
                    fontSize: 14
                  }
                },
                xAxis: {
                  type: 'category',
                  boundaryGap: false,
                  axisLabel: {
                    show: true,
                    textStyle: {
                      color: 'rgba(255, 255, 255, 0.65)'
                    }
                  },
                  splitLine: {
                    lineStyle: {
                      color: 'rgba(255, 255, 255, 0.15)'
                    }
                  },
                  data: result.xAxis.data
                },
                yAxis: {
                  type: 'value',
                  axisLabel: {
                    show: true,
                    textStyle: {
                      color: 'rgba(255, 255, 255, 0.65)'
                    }
                  }
                },
                series: result.series
              };
              console.log('echart1 option', option, JSON.stringify(option));
              _this2.echart1.setOption(option);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    transformToChart: function transformToChart(rawData, x, y) {
      var _this3 = this;
      // 1. 按品种分组
      var grouped = {};
      rawData.forEach(function (item) {
        var name = item.breedName;
        if (!grouped[name]) grouped[name] = [];
        grouped[name].push({
          x: _this3.dateFormat2Str(item[x]),
          y: item[y]
        });
      });

      // 2. 获取所有日期并排序（去重）
      var allDates = _toConsumableArray(new Set(rawData.map(function (d) {
        return _this3.dateFormat2Str(d[x]);
      }))).sort();

      // 3. 预定义颜色（每个品种不同）
      var colorPalette = ['#48E5C7', '#FF6B6B', '#FFD93D', '#6BCBFF', '#A66CFF'];

      // 4. 生成 series
      var series = Object.keys(grouped).map(function (name, index) {
        var dateMap = {};
        grouped[name].forEach(function (d) {
          dateMap[d.x] = d.y;
        });
        var color = colorPalette[index % colorPalette.length];
        return {
          name: name,
          type: 'line',
          smooth: true,
          // 平滑曲线
          symbol: 'none',
          // 不显示数据点标记
          connectNulls: true,
          // ← 关键！让 null 前后连接
          data: allDates.map(function (date) {
            var _dateMap$date;
            return (_dateMap$date = dateMap[date]) !== null && _dateMap$date !== void 0 ? _dateMap$date : null;
          }),
          color: color,
          lineStyle: {
            color: color,
            width: 2
          },
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0,
                color: color + '4D'
              },
              // 30% 透明度（十六进制）
              {
                offset: 1,
                color: color + '0D'
              } // 5% 透明度
              ]
            }
          }
        };
      });
      return {
        xAxis: {
          type: 'category',
          data: allDates
        },
        series: series
      };
    },
    getprovincialProduction: function getprovincialProduction() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var option, res, xAxisData, seriesData, _iterator, _step, item;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this4.echart2 = echarts.init(document.getElementById('provincialProduction'));
              _context2.next = 3;
              return _this4.$api['provincialProductionQuery'](_objectSpread({}, _this4.params));
            case 3:
              res = _context2.sent;
              xAxisData = [], seriesData = [];
              _iterator = _createForOfIteratorHelper(res.data);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  item = _step.value;
                  xAxisData.push(_this4.dateFormat2Str(item.reportDate));
                  seriesData.push(item.production);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              option = {
                color: ['#FF9663'],
                tooltip: {
                  trigger: 'axis'
                },
                grid: {
                  bottom: 20,
                  top: 10,
                  right: 0,
                  left: 30
                },
                xAxis: {
                  type: 'category',
                  boundaryGap: false,
                  axisLabel: {
                    show: true,
                    textStyle: {
                      color: 'rgba(255, 255, 255, 0.65)'
                    }
                  },
                  splitLine: {
                    lineStyle: {
                      color: 'rgba(255, 255, 255, 0.15)'
                    }
                  },
                  data: xAxisData
                },
                yAxis: {
                  type: 'value',
                  axisLabel: {
                    show: true,
                    textStyle: {
                      color: 'rgba(255, 255, 255, 0.65)'
                    }
                  }
                },
                series: [{
                  name: '产量',
                  type: 'line',
                  smooth: true,
                  lineStyle: {
                    width: 3,
                    color: {
                      type: 'linear',
                      x: 1,
                      y: 0,
                      x2: 0,
                      y2: 0,
                      colorStops: [{
                        offset: 0,
                        color: 'rgba(232, 76, 0, 1)' // 0% 处的颜色
                      }, {
                        offset: 1,
                        color: 'rgba(255, 150, 99, 1)' // 100% 处的颜色
                      }],
                      global: false // 缺省为 false
                    }
                  },
                  showSymbol: false,
                  areaStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: 'rgba(255, 150, 99,0.6)'
                    }, {
                      offset: 1,
                      color: 'rgba(255, 150, 99,0)'
                    }])
                  },
                  emphasis: {
                    focus: 'series'
                  },
                  data: seriesData
                }]
              };
              _this4.echart2.setOption(option);
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getlabProduction: function getlabProduction() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var option, res, xAxisData, seriesData, _iterator2, _step2, item;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this5.echart3 = echarts.init(document.getElementById('labProduction'));
              _context3.next = 3;
              return _this5.$api['labProductionQuery'](_objectSpread({}, _this5.params));
            case 3:
              res = _context3.sent;
              xAxisData = [], seriesData = [];
              _iterator2 = _createForOfIteratorHelper(res.data);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  item = _step2.value;
                  xAxisData.push(_this5.dateFormat2Str(item.reportDate));
                  seriesData.push(item.production);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              option = {
                color: ['#06F7A1'],
                tooltip: {
                  trigger: 'axis'
                },
                grid: {
                  bottom: 20,
                  top: 10,
                  right: 0,
                  left: 30
                },
                xAxis: {
                  type: 'category',
                  boundaryGap: false,
                  axisLabel: {
                    show: true,
                    textStyle: {
                      color: 'rgba(255, 255, 255, 0.65)'
                    }
                  },
                  splitLine: {
                    lineStyle: {
                      color: 'rgba(255, 255, 255, 0.15)'
                    }
                  },
                  data: xAxisData
                },
                yAxis: {
                  type: 'value',
                  axisLabel: {
                    show: true,
                    textStyle: {
                      color: 'rgba(255, 255, 255, 0.65)'
                    }
                  }
                },
                series: [{
                  name: '企业产量',
                  type: 'line',
                  smooth: true,
                  lineStyle: {
                    width: 3,
                    color: {
                      type: 'linear',
                      x: 1,
                      y: 0,
                      x2: 0,
                      y2: 0,
                      colorStops: [{
                        offset: 0,
                        color: 'rgba(48, 255, 228, 1)' // 0% 处的颜色
                      }, {
                        offset: 1,
                        color: 'rgba(6, 247, 161, 1)' // 100% 处的颜色
                      }],
                      global: false // 缺省为 false
                    }
                  },
                  showSymbol: false,
                  areaStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: 'rgba(56, 247, 161,0.7)'
                    }, {
                      offset: 1,
                      color: 'rgba(56, 247, 161,0)'
                    }])
                  },
                  emphasis: {
                    focus: 'series'
                  },
                  data: seriesData
                }]
              };
              _this5.echart3.setOption(option);
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getlabSpecies: function getlabSpecies() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this6.$api['labSpeciesQuery'](_objectSpread(_objectSpread({}, _this6.params), {}, {
                limit: 1,
                sortField: '^sort'
              }));
            case 2:
              res = _context4.sent;
              _this6.labSpeciesData = res.data.length ? res.data[0] : {};
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    getmarketPrice: function getmarketPrice() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var option, res, result;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this7.echart4 = echarts.init(document.getElementById('marketPrice'));
              _context5.next = 3;
              return _this7.$api['marketPriceQuery'](_objectSpread({}, _this7.params));
            case 3:
              res = _context5.sent;
              result = _this7.transformToChart(res.data, 'reportDate', 'price');
              option = {
                color: ['#06F7A1'],
                tooltip: {
                  trigger: 'axis'
                },
                grid: {
                  bottom: 20,
                  top: 50,
                  right: 0,
                  left: 30
                },
                legend: {
                  left: 20,
                  top: 10,
                  icon: 'rect',
                  // 方块图标
                  itemWidth: 10,
                  // 方块宽度
                  itemHeight: 10,
                  // 方块高度
                  itemGap: 20,
                  // 图例之间间距
                  textStyle: {
                    color: '#ffffff',
                    fontSize: 14
                  }
                },
                xAxis: {
                  type: 'category',
                  boundaryGap: false,
                  axisLabel: {
                    show: true,
                    textStyle: {
                      color: 'rgba(255, 255, 255, 0.65)'
                    }
                  },
                  splitLine: {
                    lineStyle: {
                      color: 'rgba(255, 255, 255, 0.15)'
                    }
                  },
                  data: result.xAxis.data
                },
                yAxis: {
                  type: 'value',
                  axisLabel: {
                    show: true,
                    textStyle: {
                      color: 'rgba(255, 255, 255, 0.65)'
                    }
                  }
                },
                series: result.series
              };
              _this7.echart4.setOption(option);
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    getregionalSales: function getregionalSales() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var option, res, data, _iterator3, _step3, item;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this8.echart5 = echarts.init(document.getElementById('regionalSales'));
              _context6.next = 3;
              return _this8.$api['regionalSalesQuery'](_objectSpread(_objectSpread({}, _this8.params), {}, {
                limit: -1,
                sortField: 'sales'
              }));
            case 3:
              res = _context6.sent;
              data = {};
              _iterator3 = _createForOfIteratorHelper(res.data);
              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  item = _step3.value;
                  if (!data[item.area]) {
                    data[item.area] = {
                      name: item.area,
                      value: item.sales
                    };
                  }
                  data[item.area].value += item.sales;
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
              option = {
                tooltip: {
                  trigger: 'item'
                },
                color: ['#FFA06C', '#44D7B6', '#00B7FF', '#089898', '#00FAFF', '#6236FF', '#c4a9e7', '#ffd8b8'],
                series: [{
                  name: '销售区域',
                  type: 'pie',
                  radius: ['40%', '70%'],
                  avoidLabelOverlap: false,
                  labelLine: {
                    show: true,
                    lineStyle: {
                      color: '#fff'
                    }
                  },
                  label: {
                    formatter: '{point|●} {b} {d}%',
                    color: '#FFFFFF',
                    alignTo: 'edge',
                    position: 'outside',
                    // 标签显示在饼图外部
                    margin: 20,
                    // 标签与饼图的间距
                    edgeDistance: 0,
                    // 标签与边缘的距离
                    rich: {
                      point: {
                        fontSize: 16,
                        // 圆点大小
                        color: 'inherit',
                        // 继承系列颜色
                        width: 20,
                        height: 16,
                        align: 'center'
                      }
                    }
                  },
                  data: Object.values(data)
                }]
              };
              _this8.echart5.setOption(option);
            case 9:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    }
  }
};